// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"a68ad517","455":"af89e979","977":"47b0aad2"}[chunkId] + ".chunk.js";
};